<template>
  <div class='teacher'>
    <list-template
        :loading="loading"
        :current-page='page'
        :search-config='searchConfig'
        :table-config='tableConfig'
        :table-data='tableData'
        :total='total'
        hasAdd
        @onAdd='$router.push("./add")'
        @onChangePage='changeCurrentPage'
        @onHandle='tableHandle'
        @onReset='search = null'
        @onSearch='onSearch'>
    </list-template>
  </div>
</template>

<script>
import searchBlock from '@/components/SearchBlock.vue';
import {mapState} from 'vuex';

export default {
	_config:{"route":{"path":"list","meta":{"title":"列表","keepAlive":true}}},
  components: {
    searchBlock,
  },

  data() { // 这里存放数据
    return {
      loading:true,
      total: 0, // 总数
      search: null, // 搜索条件
      tableData: [], // 表格中的数据
      // 表格配置
      tableConfig: [{
        prop: 'standard_name',
        label: '规格名称',
        width: 500
      }, {
        prop: 'stock',
        label: '库存',
        width: 150
      }, {
        prop: 'purchase_contract_name',
        label: '合同名称',
      }, {
        prop: 'creator',
        label: '创建人',
      }, {
        prop: 'created_at',
        label: '创建时间',
      }, {
        width: 80,
        label: '操作',
        handle: true,
        render: () => ['编辑'],
      }],
      // 表格搜索配置
      searchConfig: [{
        prop: 'standard_name',
        placeholder: '搜索规格名称',
      }],
    };
  },

  mounted() { // 生命周期 - 挂载完成（可以访问 DOM 元素）
    this.$store.commit('setPage', 1);
    this.getData();
  },

  activated() { // 如果页面有 keep-alive 缓存功能,这个函数会触发  进入的时候触发
    this.getData();
  },

  computed: { // 计算属性 类似于 data 概念
    ...mapState(['page']),
  },

  methods: { // 方法合集
    changeCurrentPage(e) { // 分页被更改
      this.$store.commit('setPage', e);
      this.getData();
    },

    getData() { // 获取数据
      let { search, page } = this;
      this.loading = true;
      this.$_register.get('api/recruit/goods-manage/goods-standard-list', { params: { ...search, page } }).then(res => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.page.total;
      }).finally(()=>this.loading = false);
    },

    onSearch(val) { // 搜索按钮被点击
      this.$store.commit('setPage', 1);
      this.search = val;
      this.getData();
    },

    tableHandle(row, text, index) { // 表格后面操作被点击
          this.$router.push('./edit?id=' + row.id);
    },
  },
};
</script>

<style scoped>
</style>
